// @flow
import type {
  NavigationRoute,
  NavigationScreenProp,
} from '@react-navigation/compat';
import React, {PureComponent} from 'react';
import {StyleSheet, View} from 'react-native';
import Permissions from 'react-native-permissions';
import {Text} from 'trpc-react-native-ui';
import {FullButton, GradientPage} from '../../../components/common';
import {PageTitle, RequiredItem} from '../../../components/signUp';
import I18n from '../../../lib/i18n';
import Toast from '../../../lib/toastService';
import theme from '../../../theme-config';
import WizzeeLog from '../../../lib/wizzeeLog';

class RequiredToActivateSim extends PureComponent<Props> {
  styles = getStyles();

  goToNextPage = () =>
    Permissions.check('camera')
      .then(response => {
        // we need to check permissions on some platforms (eg. Android 6+)
        switch (response) {
          case 'authorized':
            return true;
          case 'undetermined':
          case 'restricted':
          case 'denied':
            return Permissions.request('camera').then(response => {
              if (response === 'authorized') return true;
            });
          default:
            WizzeeLog.warn('Unknown answer', response);
        }
        return false;
      })
      .then(permitted =>
        permitted
          ? this.props.navigation.navigate('simCardManual')
          : Toast.showError(I18n.t('WelcomeScreen.cameraNeededForSIMCardScan')),
      );

  render() {
    const styles = this.styles;
    return (
      <GradientPage backgroundImage={theme.upDownStrokesBackgroundImage}>
        <View style={styles.pageContainer}>
          <View>
            <PageTitle title={I18n.t('SignUp.RequiredToActivateSim.title')} />
            <Text style={styles.subtitle}>
              {I18n.t('SignUp.RequiredToActivateSim.youWillNeed')}
            </Text>
          </View>
          <View>
            <RequiredItem
              itemDescription={I18n.t(
                'SignUp.RequiredToActivateSim.yourSimCard',
              )}
              iconName="simcard"
            />
            <RequiredItem
              itemDescription={I18n.t(
                'SignUp.RequiredToActivateSim.yourIdCard',
              )}
              iconName="user"
            />
            <RequiredItem
              itemDescription={I18n.t(
                'SignUp.RequiredToActivateSim.yourCreditCard',
              )}
              iconName="creditcard"
            />
          </View>
          <FullButton
            text={I18n.t('SignUp.RequiredToActivateSim.continue')}
            onPress={this.goToNextPage}
            testID={'getStartedButton'}
          />
        </View>
      </GradientPage>
    );
  }
}

function getStyles() {
  return StyleSheet.create({
    pageContainer: {
      flex: 1,
      justifyContent: 'space-around',
      marginHorizontal: 22,
    },
    subtitle: {
      color: theme.signUpTextColor,
      fontSize: 22,
      textAlign: 'center',
    },
  });
}

type Props = {
  navigation: NavigationScreenProp<NavigationRoute>,
};

export default RequiredToActivateSim;
